import { Injectable } from '@angular/core';
import { LoadersStorageModel } from './storage/loaders-storage.model';
import { LoaderManagement } from './loader-management';
import { LoaderNameType } from './types';
import { LoaderActions } from './loader-actions.enum';
import { ModalLoaderService } from './modal-loader.service';

/**
 * Dokumentacja
 * https://omnisquare.atlassian.net/wiki/spaces/OB/pages/edit/87162903?draftId=87195791&draftShareId=7ca70ac5-b2eb-440b-b6fc-87fad4b04401&
 **/

@Injectable()
export class LoadersService {
  // fix for AngularJS
  public loaderActions = LoaderActions;

  private storage: LoadersStorageModel = new LoadersStorageModel();

  constructor(
    private modalLoader: ModalLoaderService,
  ){
    this.modalLoader.setLoaderService(this);
  }

  private createLoader(_loaderName: LoaderNameType, ...args: any[]): LoaderManagement {
    const loader: LoaderManagement = new LoaderManagement(this.storage, _loaderName, ...args);

    this.storage.addLoader(loader);

    return loader;
  }

  private prepareLoaderForStartOrStop(
    _loaderName: LoaderNameType,
    _additionalData: any = null
  ): LoaderManagement {
    let loader: LoaderManagement = this.storage.getLoaderByName(_loaderName);

    if (!loader) {
      loader = this.createLoader(_loaderName, [], false);
    }

    if (_additionalData !== null) {
      loader.setAdditionalData(_additionalData);
    }

    return loader;
  }

  public registerLoader(
    _loaderName: LoaderNameType, _dependencyLoadersNames: Array<LoaderNameType> = []
  ): LoaderManagement {
    let loader: LoaderManagement = this.storage.getLoaderByName(_loaderName);

    if (loader) {
      if (loader.dependencyLoaders.toString() !== _dependencyLoadersNames.toString() && loader.isRegistered()) {
        console.error(`There is another loader named ${loader.loaderName}. But other dependencies.`);
      }

      if (!loader.isRegistered()) {
        loader.updateDependencyLoaders(_dependencyLoadersNames);
        loader.setRegistered();
      }
    } else {
      loader = this.createLoader(_loaderName, _dependencyLoadersNames, true);
    }

    return loader;
  }

  public start(
    _loaderName: LoaderNameType,
    _additionalData: any = null,
    _runDelay: boolean = false
  ): void {
    const loader: LoaderManagement = this.prepareLoaderForStartOrStop(_loaderName, _additionalData);

    if (_runDelay) {
      loader.onDelay();
    }

    loader.start();
  }

  public stop(
    _loaderName: LoaderNameType,
    _additionalData: any = null
  ): LoaderManagement {
    const loader: LoaderManagement = this.prepareLoaderForStartOrStop(_loaderName, _additionalData);

    if (loader.runDelay) {
      if (loader.getLoaderStorage().isInTimeOfDelay()) {
        setTimeout(function () {
          loader.stop();
          loader.runDelayNotifyAfterStop();
        }, loader.getLoaderStorage().getDelayTimeDifference());
      }
      else {
        loader.stop();
        loader.runDelayNotifyAfterStop();
      }
    }
    else {
      loader.stop();
    }

    return loader;
  }
}
